<template>
  <div class="compressed-content">
    <h3 class="page-question">Do you have any of the following diabetes-related conditions?<br /><i>(Check all that apply)</i></h3>
    <b-form-group class="card-selector page-buttons">
      <b-form-checkbox v-model="survey.bloodSugar.diabeticDiseases.hasNone"
                       @change="onNoConditionSelected">
        None
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.bloodSugar.diabeticDiseases.hasDiabeticEyeDisease"
                       @change="onEyeDiseaseSelected">
        Diabetic eye disease (retinopathy)
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.bloodSugar.diabeticDiseases.hasDiabeticKidneyDisease"
                       @change="onKidneyDiseaseSelected">
        Diabetic kidney disease (nephropathy)
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.bloodSugar.diabeticDiseases.hasDiabeticUrineProtein"
                       @change="onUrineProteinSelected">
        Increased protein in your urine (albuminuria)
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.bloodSugar.diabeticDiseases.hasDiabeticNumbness"
                       @change="onNumbnessSelected">
        Numbness, tingling, decreased sensation, or pain in your extremities (neuropathy)
      </b-form-checkbox>
    </b-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');

  export default {
    mixins: [formMixin],

    computed: {
      ...mapState(["survey"]),

      diabeticDiseases() { return this.survey.bloodSugar.diabeticDiseases; }
    },

    methods: {
      onNoConditionSelected() {
        this.survey.bloodSugar.diabeticDiseases.hasNone = true;
        this.survey.bloodSugar.diabeticDiseases.hasDiabeticEyeDisease = false;
        this.survey.bloodSugar.diabeticDiseases.hasDiabeticKidneyDisease = false;
        this.survey.bloodSugar.diabeticDiseases.hasDiabeticUrineProtein = false;
        this.survey.bloodSugar.diabeticDiseases.hasDiabeticNumbness = false;
      },

      onEyeDiseaseSelected(value) {
        this.survey.bloodSugar.diabeticDiseases.hasNone = false;
        this.survey.bloodSugar.diabeticDiseases.hasDiabeticEyeDisease = value;
      },

      onKidneyDiseaseSelected(value) {
        this.survey.bloodSugar.diabeticDiseases.hasNone = false;
        this.survey.bloodSugar.diabeticDiseases.hasDiabeticKidneyDisease = value;
      },

      onUrineProteinSelected(value) {
        this.survey.bloodSugar.diabeticDiseases.hasNone = false;
        this.survey.bloodSugar.diabeticDiseases.hasDiabeticUrineProtein = value;
      },

      onNumbnessSelected(value) {
        this.survey.bloodSugar.diabeticDiseases.hasNone = false;
        this.survey.bloodSugar.diabeticDiseases.hasDiabeticNumbness = value;
      }
    }
  };
</script>